import { combineReducers } from 'redux';
import interfaceReducer from './interfaceReducer';

const rootReducer = combineReducers({
        interface: interfaceReducer
});

export default rootReducer;
